import { registerSettingComponent, registerWidget } from "dmeditor";
import definition from "./definition";
import { ClubInfo } from "./ClubInfo";
import { serverImport } from "../../serverImport";

const register = () => {
  registerWidget(definition, {
    render: ClubInfo,
    onServerSideLoad: serverImport(() => import("./onServerSideLoad")),
  });
};

export default register;
